import { ConnectError } from "@connectrpc/connect";
import { errorInfoOf } from "@fox1ck-org/auth/saas";

import { t } from "@/lib/i18n";

/**
 * What a failed request says to a person: a Connect failure's own cause
 * (`rawMessage` — `message` prefixes the code, «[internal] …»), else the
 * error's message. The package's PageState reads a string as it is, so every
 * screen hands it this rather than the error.
 */
export function errorText(error: unknown): string {
  // A campaign managed by its import source: a neutral sentence, not the server's wording.
  if (errorInfoOf(error)?.reason === "locked_by_source") return t("plan.refusal.lockedBySource");
  if (error instanceof ConnectError) return error.rawMessage || error.message;
  if (error instanceof Error) return error.message;
  return typeof error === "string" ? error : "";
}

/** `errorText`, or «Не удалось загрузить» when the failure says nothing — what an error PageState shows. */
export function failureText(error: unknown): string {
  return errorText(error) || t("lib.common.failed");
}
